import { render } from "./tasks-model.vue?vue&type=template&id=0887d2b1"
import script from "./tasks-model.vue?vue&type=script&lang=js"
export * from "./tasks-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__